import { handleActions } from "redux-actions";

import { PAYMENTS_MANAGEMENT } from "constants/action-types";

interface IError {
    message: string;
    request: any;
    status: number;
    xhr: any;
}

interface IState {
    result: string[];
    isFetching: boolean;
    isCreating: boolean;
    error: boolean;
    errorObject: IError | undefined;
}

const initialState = {
    result: [],
    isFetching: false,
    isCreating: false,
    error: false,
    errorObject: undefined,
};

const statementsReducer = handleActions<IState, any>(
    {
        [PAYMENTS_MANAGEMENT.STATEMENTS.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
                error: false,
            };
        },
        [PAYMENTS_MANAGEMENT.STATEMENTS.FETCH.COMPLETED]: (state: IState, response): IState => {
            const { payload, error } = response;

            if (error) {
                return {
                    ...state,
                    result: [],
                    isFetching: false,
                    error,
                    errorObject: payload,
                };
            }
            return {
                ...state,
                result: payload,
                isFetching: false,
                error,
            };
        },
        [PAYMENTS_MANAGEMENT.STATEMENTS.CREATE.START]: (state: IState): IState => {
            return {
                ...state,
                isCreating: true,
            };
        },
        [PAYMENTS_MANAGEMENT.STATEMENTS.CREATE.COMPLETED]: (state: IState, response): IState => {
            const { payload, error } = response;

            if (error) {
                return {
                    ...state,
                    isCreating: false,
                    error,
                    errorObject: payload,
                };
            }
            return {
                ...state,
                isCreating: false,
            };
        },
    },
    initialState
);
export type IStatementState = IState;

export default statementsReducer;
